/**
 * Whether an HTTP answer says the author's session was superseded — they signed in elsewhere — which
 * is the one 401 that ends the session on every host. It says so in the `x-logout-reason` header, in
 * the body's `error`, or in `www-authenticate`. Any other 401 is an ordinary request failure.
 */
export function isSessionSuperseded(res?: any): boolean {
  const reasonHeader = res?.headers?.['x-logout-reason'];
  const bodyError = res?.data?.error;
  const www = (res?.headers?.['www-authenticate'] || '').toString().toLowerCase();
  return res?.status === 401 && (reasonHeader === 'session_superseded' || bodyError === 'session_superseded' || www.includes('session_superseded'));
}
